"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentType = void 0;
/** 组件类型 */
var ComponentType;
(function (ComponentType) {
    ComponentType["Enum"] = "enum";
    ComponentType["Input"] = "input";
    ComponentType["Empty"] = "empty";
    ComponentType["Ref"] = "ref";
    ComponentType["Group"] = "group";
    ComponentType["SpuMeta"] = "spu-meta";
})(ComponentType || (exports.ComponentType = ComponentType = {}));
